import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';
import { getStyles } from '../../../../shared/utility';

import Button from '../../../UI/Button/Button';
import Icon from '../../../UI/Icon/Icon';

import localStyles from './SearchAutocomplete.scss';
const styles = getStyles(localStyles);

const searchAutocomplete = (props) => {
    const autocompleteElement = props.searchAutocompleteData.map((item, index) => (
        <li key={index}
            className={styles('autocomplete__item', (props.hilighted === index ? 'autocomplete__item--hilighted' : null))}
            onMouseEnter={() => props.updateHilighted(index)}
        >
            <Button
                modifiers={['text', 'stretch']}
                classes={styles('autocomplete__item__button')}
                events={{ click: () => props.getSearchLocationDetails(item.place_id)}}
            >
                <Icon icon={'location'} modifiers={['inline']} />
                <span className={styles('autocomplete__item__content')}>
                    {item.description}
                </span>
            </Button>
        </li>
    ));

    return (
        <ul className={styles('autocomplete', 'no-list-style')}>
            {autocompleteElement}
        </ul>
    );

};

searchAutocomplete.propTypes = {
    // properties
    hilighted: PropTypes.number.isRequired,

    searchAutocompleteData: PropTypes.arrayOf(PropTypes.object).isRequired,

    // functions
    getSearchLocationDetails: PropTypes.func.isRequired,
    updateHilighted: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        searchAutocompleteData: state.list.searchAutocomplete.data,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSearchLocationDetails: (locationId) => dispatch(actions.fetchSearchLocationDetails(locationId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(searchAutocomplete);



// WEBPACK FOOTER //
// ./src/components/Navigation/SearchFocus/SearchAutocomplete/SearchAutocomplete.js